import script from "./MessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageModal.vue?vue&type=script&setup=true&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=0887ab44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0887ab44"]])

export default __exports__